var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValidation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5208 8.70278L11.6068 22.8583C10.8969 23.5806 9.83208 23.5806 9.12218 22.8583L0.532423 14.1194C-0.177474 13.3972 -0.177474 12.3139 0.532423 11.5917L2.87509 9.28056C3.58498 8.55833 4.64983 8.55833 5.35973 9.28056L8.69625 12.675C9.61911 13.6139 11.1099 13.6139 12.0328 12.675L20.6935 3.79167C21.4034 3.06944 22.4683 3.06944 23.1782 3.79167L25.5208 6.175C26.1597 6.825 26.1597 7.98056 25.5208 8.70278Z",
    fill: "#100E10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidation);
export default __webpack_public_path__ + "static/media/validation.a31915b4.svg";
export { ForwardRef as ReactComponent };